import { render, staticRenderFns } from "./CompanyProfileItem.vue?vue&type=template&id=74adfb6c"
import script from "./CompanyProfileItem.vue?vue&type=script&lang=js"
export * from "./CompanyProfileItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports